export default "__VITE_ASSET__D79QWg0w__"